<template>
    <keep-alive>
        <div style="z-index: 101; position: relative">
            <div
                id="checkClickChallenge2"
                class="question-roullette"
                v-if="questionRoullette && payloadRoulette.n_type == 'challenge_accepted'"
            >
                {{ payloadRoulette.from_user_object.name_first }} {{ payloadRoulette.from_user_object.name_last }} is in
                the Playing room.
                <div class="flex-center">
                    <div @click="goToRoullete" class="btn_roullete"><b>Play</b></div>
                    <div @click="cancelToRoullete" class="btn_roullete btn_roullete_cancel">Ignore</div>
                </div>
            </div>
            <!--RATING POPUP-->
            <div
                id="checkClickRating"
                class="question-roullette zero"
                :class="{ 'opacity-zero': popupEasyLeave, 'opacity-one': popupEasyEnter }"
                v-if="popupRatingDif && $store.state.myChallengesComplete[0]"
            >
                <div>
                    <div class="rating-dif-text" v-if="$store.state.myChallengesComplete[0].r_diff < 0">
                        <p>
                            {{ randomMessage
                            }}<span><img src="@/components/SVG/Sidebar/rating-down.svg" alt="rating-down" /></span>
                        </p>
                    </div>
                    <div class="rating-dif-text" v-if="$store.state.myChallengesComplete[0].r_diff > 0">
                        <p>
                            {{ randomMessage
                            }}<span><img src="@/components/SVG/Sidebar/rating-up.svg" alt="rating-up" /></span>
                        </p>
                    </div>
                </div>
                <div class="flex-center">
                    <div @click="popupRatingDif = !popupRatingDif" style class="btn_roullete">Close</div>
                </div>
            </div>
            <!--  INITIATE BANNER  -->
            <div
                id="checkClickChallenge3"
                class="initiate-banner"
                :class="{
                    'banner-pages-position-problem':
                        (location == 'tournament-calendar' || locationhref.indexOf('publicprofile') !== -1) &&
                        challenged,
                    'banner-position':
                        challenged && location !== 'tournament-calendar' && locationhref.indexOf('publicprofile') == -1,
                }"
            >
                <!-- {{ payloadRoulette.from_user_object.name_first }} {{ payloadRoulette.from_user_object.name_last }} is in -->
                <div v-if="payloadIniciationChallenge.from_user_object" class="banner-text">
                    <span class="color-blue">
                        {{ payloadIniciationChallenge.from_user_object.name_first }}
                        {{ payloadIniciationChallenge.from_user_object.name_last }}
                    </span>
                    challenged you to a
                    <span> {{ payloadIniciationChallenge.data.ch_type }}, </span>
                    <span v-if="payloadIniciationChallenge.data.ch_amount < 1">friendly </span>match
                    <span v-if="payloadIniciationChallenge.data.ch_amount > 0">
                        for €{{ Math.round((payloadIniciationChallenge.data.ch_amount * 0.9090909).toFixed(2)) }}.</span
                    >
                </div>
                <div class="flex-center">
                    <div @click="challangeAccept(payloadIniciationChallenge, 'accept')" class="btn_roullete">
                        <b>Play</b>
                    </div>
                    <div @click="challenged = false" class="btn_roullete btn_roullete_cancel">Ignore</div>
                </div>
            </div>

            <div
                id="checkClickChallenge"
                class="question-roullette"
                v-if="questionRoullette && payloadRoulette.n_type == 'challenge_started'"
            >
                Go to your 1vs1 match and wait for your opponent {{ payloadRoulette.from_user_object.name_first }}
                {{ payloadRoulette.from_user_object.name_last }}.
                <div class="flex-center">
                    <div @click="goToRoullete" class="btn_roullete"><b>Go</b></div>
                    <div @click="cancelToRoullete" class="btn_roullete btn_roullete_cancel">Ignore</div>
                </div>
            </div>
            <div class="side-bar" :class="{ open: isOpen }">
                <div class="top">
                    <div v-if="onHome" style="cursor: pointer" @click="goToHome">
                        <div class="logoimg">
                            <img src="@/assets/outpost_logo.svg" alt="logo" />
                        </div>
                    </div>
                    <router-link v-else :to="{ name: 'HomePage' }">
                        <div style="cursor: pointer">
                            <div class="logoimg">
                                <img src="@/assets/outpost_logo.svg" alt="logo" />
                            </div>
                        </div>
                    </router-link>
                    <img class="close-icon" src="../assets/close.svg" alt="close icon" @click="closeSidebar" />
                </div>

                <div v-if="userId" class="options">
                    <router-link :to="{ name: 'OnlineUsers' }">
                        <div id="wallet" class="side-options sm-hide">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeOnline }"
                                        d="M0-240v-63q0-43 44-70t116-27q13 0 25 .5t23 2.5q-14 21-21 44t-7 48v65H0Zm240 0v-65q0-32 17.5-58.5T307-410q32-20 76.5-30t96.5-10q53 0 97.5 10t76.5 30q32 20 49 46.5t17 58.5v65H240Zm540 0v-65q0-26-6.5-49T754-397q11-2 22.5-2.5t23.5-.5q72 0 116 26.5t44 70.5v63H780Zm-455-80h311q-10-20-55.5-35T480-370q-55 0-100.5 15T325-320ZM160-440q-33 0-56.5-23.5T80-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T160-440Zm640 0q-33 0-56.5-23.5T720-520q0-34 23.5-57t56.5-23q34 0 57 23t23 57q0 33-23 56.5T800-440Zm-320-40q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-600q0 50-34.5 85T480-480Zm0-80q17 0 28.5-11.5T520-600q0-17-11.5-28.5T480-640q-17 0-28.5 11.5T440-600q0 17 11.5 28.5T480-560Zm1 240Zm-1-280Z"
                                    />
                                </svg>
                                <!-- <svg xml   ns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#ceceda"><path d="M240-400q0 52 21 98.5t60 81.5q-1-5-1-9v-9q0-32 12-60t35-51l113-111 113 111q23 23 35 51t12 60v9q0 4-1 9 39-35 60-81.5t21-98.5q0-50-18.5-94.5T648-574q-20 13-42 19.5t-45 6.5q-62 0-107.5-41T401-690q-39 33-69 68.5t-50.5 72Q261-513 250.5-475T240-400Zm240 52-57 56q-11 11-17 25t-6 29q0 32 23.5 55t56.5 23q33 0 56.5-23t23.5-55q0-16-6-29.5T537-292l-57-56Zm0-492v132q0 34 23.5 57t57.5 23q18 0 33.5-7.5T622-658l18-22q74 42 117 117t43 163q0 134-93 227T480-80q-134 0-227-93t-93-227q0-129 86.5-245T480-840Z"/></svg> -->
                                <!-- <img style="scale: 1.15" src="@/components/SVG/Sidebar/match.svg" alt="" /> -->
                            </div>
                            <div style="position: relative">
                                <p class="left-sidetext diffcol" :class="{ clicked: activeOnline }">Online Players</p>
                                <div class="absolute-new green">1 vs 1</div>
                            </div>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </router-link>
                    <div id="home">
                        <div v-if="onHome" class="side-options" @click="goToHome()">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeHome }"
                                        d="M192-144v-337l-64 49-44-58 396-302 396 302-44 58-64-49v337H192Zm72-72h432v-320.33L480-701 264-537v321Zm0 0h432-432Zm72.21-144q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Z"
                                    />
                                </svg>
                            </div>
                            <p class="left-sidetext diffcol" :class="{ clicked: activeHome }">Home</p>
                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                        <router-link v-else :to="{ name: 'HomePage' }">
                            <div id="home1" class="side-options">
                                <div class="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="22px"
                                        viewBox="0 -960 960 960"
                                        width="22px"
                                        fill="#ceceda"
                                    >
                                        <path
                                            :class="{ clicked: activeHome }"
                                            d="M192-144v-337l-64 49-44-58 396-302 396 302-44 58-64-49v337H192Zm72-72h432v-320.33L480-701 264-537v321Zm0 0h432-432Zm72.21-144q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Zm144 0q-15.21 0-25.71-10.29t-10.5-25.5q0-15.21 10.29-25.71t25.5-10.5q15.21 0 25.71 10.29t10.5 25.5q0 15.21-10.29 25.71t-25.5 10.5Z"
                                        />
                                    </svg>
                                </div>
                                <p class="left-sidetext diffcol" :class="{ clicked: activeHome }">Home</p>
                                <img class="arrow" src="../assets/expand-more.svg" alt="" />
                            </div>
                        </router-link>
                    </div>

                    <div>
                        <div @click="goToProfile()">
                            <div id="my-profile" class="side-options" @click="closeSidebar">
                                <div class="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="22px"
                                        viewBox="0 -960 960 960"
                                        width="22px"
                                        fill="#ceceda"
                                    >
                                        <path
                                            :class="{ clicked: activeProfile }"
                                            d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"
                                        />
                                    </svg>
                                </div>
                                <p class="left-sidetext" :class="{ clicked: activeProfile }">My profile</p>
                                <img class="arrow" src="../assets/expand-more.svg" alt="" />
                            </div>
                        </div>
                    </div>
                    <router-link :to="{ name: 'Chatroom' }">
                        <div id="inbox" class="side-options" @click="closeSidebar">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeChatroom }"
                                        d="M160-160q-33 0-56.5-23.5T80-240v-480q0-33 23.5-56.5T160-800h640q33 0 56.5 23.5T880-720v480q0 33-23.5 56.5T800-160H160Zm320-280L160-640v400h640v-400L480-440Zm0-80 320-200H160l320 200ZM160-640v-80 480-400Z"
                                    />
                                </svg>
                            </div>
                            <p class="left-sidetext" :class="{ clicked: activeChatroom }">Inbox</p>
                            <div v-show="unreadMessage" id="message_notification" class="flex-center" />
                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </router-link>
                    <router-link :to="{ name: 'Intsearch' }">
                        <div id="intelligent-search" class="side-options search" @click="closeSidebar">
                            <div class="icon">
                                <svg
                                    width="22"
                                    height="22"
                                    viewBox="0 0 21 14"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        :class="{ clicked: activeSearch }"
                                        d="M19.5002 12.9662L15.8481 9.2668L15.704 9.12084L15.5327 9.23363C14.7701 9.73572 13.8774 10.0332 12.9102 10.0332C10.2913 10.0332 8.16016 7.87913 8.16016 5.21838C8.16016 2.55763 10.2913 0.403564 12.9102 0.403564C15.5291 0.403564 17.6602 2.55763 17.6602 5.21838C17.6602 6.20053 17.3657 7.10578 16.8705 7.86781L16.7611 8.03627L16.902 8.17943L20.5591 11.8936L19.5002 12.9662ZM5.66016 2.94245H1.16016V1.41653H5.66016V2.94245ZM1.16016 8.00727V6.48134H5.66016V8.00727H1.16016ZM16.1602 5.21838C16.1602 3.41196 14.7013 1.92949 12.9102 1.92949C11.1191 1.92949 9.66016 3.41196 9.66016 5.21838C9.66016 7.02479 11.1191 8.50727 12.9102 8.50727C14.7013 8.50727 16.1602 7.02479 16.1602 5.21838ZM10.6602 11.5462V13.0721H1.16016V11.5462H10.6602Z"
                                        fill="#Ceceda"
                                        stroke="#ceceda"
                                        stroke-width="0.2"
                                    />
                                </svg>
                            </div>

                            <p class="left-sidetext" :class="{ clicked: activeSearch }">Search</p>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </router-link>
                    <!--    <div class="side-options lg-hide">
                <div class="icon">
                    <img src="../assets/hands.png" alt="" />
                </div>
                <p class="left-sidetext diffcol">My connections</p>
            </div>  -->
                    <router-link :to="{ name: 'TournamentCalendar' }">
                        <div id="tournament-calendar" class="side-options" @click="closeSidebar">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    style="margin-left: -1.5px"
                                    height="22"
                                    viewBox="0 96 960 960"
                                    width="22"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeTour }"
                                        d="M587.693 816q-38.538 0-65.423-26.884-26.884-26.885-26.884-65.423t26.884-65.423q26.885-26.884 65.423-26.884t65.423 26.884Q680 685.155 680 723.693t-26.884 65.423Q626.231 816 587.693 816ZM212.309 955.999q-30.308 0-51.308-21t-21-51.308V348.309q0-30.308 21-51.308t51.308-21h55.385v-84.615h61.537v84.615h303.076v-84.615h59.999v84.615h55.385q30.308 0 51.308 21t21 51.308v535.382q0 30.308-21 51.308t-51.308 21H212.309Zm0-59.999h535.382q4.616 0 8.463-3.846 3.846-3.847 3.846-8.463V508.309H200v375.382q0 4.616 3.846 8.463 3.847 3.846 8.463 3.846ZM200 448.31h560V348.309q0-4.616-3.846-8.463-3.847-3.846-8.463-3.846H212.309q-4.616 0-8.463 3.846-3.846 3.847-3.846 8.463V448.31Zm0 0V336v112.31Z"
                                        fill="#Ceceda"
                                        stroke="#ceceda"
                                        stroke-width="0.4%"
                                    />
                                </svg>
                            </div>

                            <p class="left-sidetext" :class="{ clicked: activeTour }">Tournaments</p>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </router-link>
                    <!--   <router-link to="../wallet">-->

                    <router-link :to="{ name: 'WalletOutpost' }">
                        <div id="wallet" class="side-options wallet">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeWallet }"
                                        d="M200-200v-560 560Zm0 80q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v100h-80v-100H200v560h560v-100h80v100q0 33-23.5 56.5T760-120H200Zm320-160q-33 0-56.5-23.5T440-360v-240q0-33 23.5-56.5T520-680h280q33 0 56.5 23.5T880-600v240q0 33-23.5 56.5T800-280H520Zm280-80v-240H520v240h280Zm-160-60q25 0 42.5-17.5T700-480q0-25-17.5-42.5T640-540q-25 0-42.5 17.5T580-480q0 25 17.5 42.5T640-420Z"
                                    />
                                </svg>
                                <!-- <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 -960 960 960" width="22px" fill="#ceceda" ><path d="M240-160q-66 0-113-47T80-320v-320q0-66 47-113t113-47h480q66 0 113 47t47 113v320q0 66-47 113t-113 47H240Zm0-480h480q22 0 42 5t38 16v-21q0-33-23.5-56.5T720-720H240q-33 0-56.5 23.5T160-640v21q18-11 38-16t42-5Zm-74 130 445 108q9 2 18 0t17-8l139-116q-11-15-28-24.5t-37-9.5H240q-26 0-45.5 13.5T166-510Z"/></svg> -->
                            </div>
                            <p class="left-sidetext diffcol" :class="{ clicked: activeWallet }">Wallet</p>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </router-link>

                    <!-- </router-link> -->
                    <div class="side-flexend2"></div>

                    <div class="border-top sm-show"></div>

                    <div class="option-down" :class="{ 'option-down-active': $store.state.moreSidebar }">
                        <div
                            v-show="$store.state.moreSidebar"
                            @click="goLinkupList"
                            id="wallet"
                            class="side-options opacity"
                            style="margin-top: 0.625rem"
                        >
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeLinkup }"
                                        d="M440-280H280q-83 0-141.5-58.5T80-480q0-83 58.5-141.5T280-680h160v80H280q-50 0-85 35t-35 85q0 50 35 85t85 35h160v80ZM320-440v-80h320v80H320Zm200 160v-80h160q50 0 85-35t35-85q0-50-35-85t-85-35H520v-80h160q83 0 141.5 58.5T880-480q0 83-58.5 141.5T680-280H520Z"
                                    />
                                </svg>
                            </div>
                            <div style="position: relative">
                                <p class="left-sidetext diffcol" :class="{ clicked: activeLinkup }">Link-up</p>
                            </div>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>

                        <router-link :to="{ name: 'TrainerList' }">
                            <div v-show="$store.state.moreSidebar" id="wallet" class="side-options">
                                <div class="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="24px"
                                        viewBox="0 -960 960 960"
                                        width="24px"
                                        fill="#ceceda"
                                    >
                                        <path
                                            :class="{ clicked: activeTrainer }"
                                            d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z"
                                        />
                                    </svg>
                                </div>
                                <div style="position: relative">
                                    <p class="left-sidetext diffcol" :class="{ clicked: activeTrainer }">Trainers</p>
                                </div>

                                <img class="arrow" src="../assets/expand-more.svg" alt="" />
                            </div>
                        </router-link>
                    </div>

                    <div
                        @click="moreLinesSidebar"
                        class="side-options opacity"
                        style="margin-top: 0.625rem; cursor: pointer"
                    >
                        <div :class="{ rotate180: $store.state.moreSidebar }" class="icon">
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24px"
                                viewBox="0 -960 960 960"
                                width="24px"
                                fill="#ceceda"
                            >
                                <path d="M480-344 240-584l56-56 184 184 184-184 56 56-240 240Z" />
                            </svg>
                        </div>
                        <div style="position: relative">
                            <p v-if="!$store.state.moreSidebar" class="left-sidetext diffcol">See more</p>
                            <p v-else class="left-sidetext diffcol">See less</p>
                        </div>
                    </div>
                    <!--     <div class="side-options blog" @click="openInvite">
                    <div class="icon">


                        
<svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 24 24" height="24px" viewBox="0 0 24 24" width="24px" fill="#c7c9d0"><g><rect fill="none" height="24" width="24"/></g><g><path d="M13,8c0-2.21-1.79-4-4-4S5,5.79,5,8s1.79,4,4,4S13,10.21,13,8z M11,8c0,1.1-0.9,2-2,2S7,9.1,7,8s0.9-2,2-2S11,6.9,11,8z M1,18v2h16v-2c0-2.66-5.33-4-8-4S1,15.34,1,18z M3,18c0.2-0.71,3.3-2,6-2c2.69,0,5.78,1.28,6,2H3z M20,15v-3h3v-2h-3V7h-2v3h-3v2 h3v3H20z"/></g></svg>
                    </div>

                    <p class="left-sidetext diffcol">Invite Friends</p>
                    
                </div>
                <div v-if="inviteComponent" class="invite">
                    <Invite />
                </div>  -->

                    <!-- <div class="side-flexend2"></div>-->

                    <!--    <div class="side-options disabled settings">
                <div style="opacity: 0.3" class="icon">
                    <img src="../assets/settings_24px_rounded.svg" alt="" />
                </div>
                <p class="left-sidetext diffcol" style="opacity: 0.3">Settings</p>
            </div>  -->
                    <!--    <div class="side-options disabled">
                <div style="opacity: 0.3" class="icon">
                    <img src="../assets/Vector7.png" alt="" />
                </div>
                <p class="left-sidetext diffcol" style="opacity: 0.3">Help</p>
            </div> -->
                    <!--   <div class="side-options disabled contact">
                    <div style="opacity: 0.3" class="icon">
                        <img src="../assets/Vector4.png" alt="" />
                    </div>
                    <p class="left-sidetext diffcol" style="opacity: 0.3">Contact Us</p>
                </div>-->
                </div>

                <div v-else class="options">
                    <div id="wallet" class="side-options sm-hide" style="opacity: 0.3">
                        <div class="icon">
                            <img style="scale: 1.15" src="@/components/SVG/Sidebar/match.svg" alt="" />
                        </div>
                        <div style="position: relative">
                            <p class="left-sidetext diffcol">Online Players</p>
                            <div class="absolute-new green">1 vs 1</div>
                        </div>

                        <img class="arrow" src="../assets/expand-more.svg" alt="" />
                    </div>

                    <div id="home" class="side-options" style="opacity: 0.3">
                        <div class="icon">
                            <img src="../assets/home_24px.png" alt="" />
                        </div>
                        <p class="left-sidetext diffcol2">Home</p>
                    </div>
                    <div>
                        <div class="side-options" style="opacity: 0.3">
                            <div class="icon">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height="22px"
                                    viewBox="0 -960 960 960"
                                    width="22px"
                                    fill="#ceceda"
                                >
                                    <path
                                        :class="{ clicked: activeProfile }"
                                        d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34 17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5 14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 33 23.5 56.5T480-560Zm0-80Zm0 400Z"
                                    />
                                </svg>
                            </div>
                            <p class="left-sidetext diffcol2" :class="{ clicked: activeProfile }">My profile</p>
                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </div>

                    <div id="inbox" class="side-options" style="opacity: 0.3">
                        <div class="icon">
                            <img src="../assets/mail_outline_24px.png" alt="" />
                        </div>
                        <p class="left-sidetext diffcol2">Inbox</p>
                        <div v-if="unreadMessage" id="message_notification" class="flex-center" />
                        <img class="arrow" src="../assets/expand-more.svg" alt="" />
                    </div>

                    <div id="search" class="side-options search" style="opacity: 0.3">
                        <div class="icon">
                            <img src="../assets/Vector5.png" alt="" />
                        </div>

                        <p class="left-sidetext diffcol2">Search</p>

                        <img class="arrow" src="../assets/expand-more.svg" alt="" />
                    </div>

                    <div id="calendar" class="side-options" style="opacity: 0.3">
                        <div class="icon">
                            <img src="../assets/tournament-icon-white.svg" alt="" />
                        </div>

                        <p class="left-sidetext diffcol2">Tournaments</p>

                        <img class="arrow" src="../assets/expand-more.svg" alt="" />
                    </div>

                    <div id="wallet" class="side-options wallet" style="opacity: 0.3">
                        <div class="icon">
                            <img src="../assets/wallet.svg" alt="wallet" />
                        </div>
                        <p class="left-sidetext diffcol2">Wallet</p>
                    </div>

                    <!-- <div id="blog" style="opacity: 0.3" class="side-options blog">
                    <div class="icon">
                        <img src="../assets/book.png" alt="" />
                    </div>

                    <p class="left-sidetext diffcol2">Blog</p>
                </div> -->
                </div>
                <!--<div class="side-flexend2"></div>-->
                <button v-if="userId" class="buttons flex-center desktop" type="button" @click="logOut">
                    Sign Out
                </button>
                <div v-else>
                    <button @click="signIn" class="middle2-buttons signin flex-center" type="button">Sign In</button>

                    <button @click="signUp" class="middle2-buttons signup flex-center" type="button">Sign Up</button>
                </div>

                <div class="demo-links sm-hide">
                    <!-- <a
                        href="http://localhost:4200/room/new/opwSUaBFW?activity=match&type=bestOf&rounds=1&timeClass=rapid&challengerId=czeKS1Q0JDSXJ&challengeeId=8UWCweKl1Gvoi&startColor=white&userId=8UWCweKl1Gvoi&userDisplayName=Dragutin&theme=op"
                    > -->

                    <!-- </a> -->
                    <!-- <a @click="refreshRoom('lesson')" :href="linkupLink">
                        <div id="wallet" class="side-options flex-center">
                            <div class="flex-center color-line-div">
                                <div class="color-line-red"></div>
                            </div>
                            <div style="position: relative" class="flex-center2">
                                <p style="text-wrap: nowrap" class="left-sidetext diffcol">Link-up demo</p>
                            </div>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </a> -->
                    <!-- <a @click="refreshRoom('link')" :href="lessonLink">
                        <div id="wallet" class="side-options flex-center">
                            <div class="flex-center color-line-div">
                                <div class="color-line-blue"></div>
                            </div>
                            <div style="position: relative" class="flex-center2">
                                <p style="text-wrap: nowrap" class="left-sidetext diffcol">Lesson demo</p>
                            </div>

                            <img class="arrow" src="../assets/expand-more.svg" alt="" />
                        </div>
                    </a> -->
                </div>
            </div>
        </div>
    </keep-alive>
</template>

<script>
import { checkToken } from "@/utils/checkToken";
import socketUtil from "@/socket";
import Cookies from "js-cookie";
export default {
    name: "SideBar",
    props: {
        msg: String,
        isOpen: Boolean,
    },

    data() {
        return {
            messages_contact_alert: [],
            unreadMessage: false,
            userId: [],
            inviteComponent: false,
            onHome: false,
            linkBackTour: "",
            linkupLink: "",
            lessonLink: "",
            questionRoullette: false,
            roulleteURL: "",
            payloadRoulette: "",
            challenged: false,
            payloadIniciationChallenge: "",
            location: "",
            locationhref: "",
            activeChatroom: false,
            activeSearch: false,
            activeProfile: false,
            activeWallet: false,
            activeTour: false,
            activeHome: false,
            activeOnline: false,
            activeLinkup: false,
            activeTrainer: false,
            newToken: "",
            popupRatingDif: false,
            popupEasyLeave: false,
            popupEasyEnter: false,
            randomMessage: "",
        };
    },
    watch: {
        // "$store.state.outpostRating.dif"() {
        //     this.popupRating();
        // },
        "$store.state.myChallenges"() {
            this.popupRating();
        },
        "$store.state.reload"() {
            this.messageAlert();
        },
        unreadMessage() {
            this.$store.commit("MESSAGE_ALERT", this.unreadMessage);
        },
        challenged(e) {
            if (e) {
                document.addEventListener("click", this.closeIfClickedOutside);
            }
        },
        questionRoullette(e) {
            //console.log("prvi deo");
            if (e) {
                document.addEventListener("click", this.closeIfClickedOutside);
            }
        },
    },
    created() {
        if (window.location.href.split("/").pop() == "home-page") {
            this.onHome = true;
        }
        this.userId = localStorage.getItem("id");
        socketUtil.subscribe();
        socketUtil.subscribe("tb_notification", this.receiveMessageSidebar);
        socketUtil.subscribe("users_online", this.receiveOnlineList);
        socketUtil.subscribe("frontend_version", this.frontend_version);
        //   socketUtil.subscribe("server_message", this.provera);
        // if (localStorage.getItem("token")) {
        // console.log("store messages", this.$store.state.message_info);
        /* fetch(process.env.VUE_APP_URL + "/message", {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
            })
                .then(response => response.json())
                .then(data => (this.messages_contact_alert = data))
                // .then(data => console.log('krkelini',data))  */
        // setTimeout(() => this.messageAlert(), 500)
        // }
    },
    mounted() {
        this.messageAlert();
        this.location = window.location.href.split("/").pop();

        this.locationhref = window.location.href;
        if (this.location == "chatroom") {
            this.activeChatroom = true;
        } else if (this.location == "intsearch") {
            this.activeSearch = true;
        } else if (this.locationhref.includes("publicprofile") && this.location !== "1") {
            this.activeProfile = true;
        } else if (this.location == "wallet") {
            this.activeWallet = true;
        } else if (this.location == "tournament-calendar") {
            this.activeTour = true;
        } else if (this.location == "home-page") {
            this.activeHome = true;
        } else if (this.location == "online-list") {
            this.activeOnline = true;
        } else if (this.location == "linkup-list") {
            this.activeLinkup = true;
        } else if (this.location == "trainer-list") {
            this.activeTrainer = true;
        }
        // let room = Array(7)
        //     .fill()
        //     .map(() => "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.random() * 62))
        //     .join("");

        // this.linkupLink = `https://play.outpostchess.com/room/new/op${room}?activity=meetup&theme=op&star=1`;
        // this.lessonLink = `http://localhost:4200/room/new/op${room}?activity=learn&theme=op&instructor=1&pgn=1. d4 d6`;
    },
    methods: {
        popupRating() {
            const pointsGained = this.$store?.state.myChallengesComplete[0]?.r_diff;
            console.log(this.$store.state.myChallengesComplete[0].r_diff);
            if (this.$store.state.myChallengesComplete[0].r_diff > 0) {
                const victoryTextTemplates = {
                    1: () => `Nice! You just earned +${pointsGained} rating points!`,
                    2: () => `Victory! +${pointsGained} points added to your rating.`,
                    3: () => `Awesome. +${pointsGained} rating gained!`,
                    4: () => `Another win in the books. +${pointsGained} rating points!`,
                };
                this.randomMessage = victoryTextTemplates[Math.floor(Math.random() * 4) + 1]();
            } else if (this.$store.state.myChallengesComplete[0].r_diff < 0) {
                const loseTextTemplates = {
                    1: () => `You'll get 'em next time. ${pointsGained}  rating points this time.`,
                    2: () => `Chess gods weren’t on your side. ${pointsGained} rating.`,
                    3: () => `Tough one. ${pointsGained} rating points this time.`,
                    4: () => `You lost ${pointsGained} rating points.`,
                };
                this.randomMessage = loseTextTemplates[Math.floor(Math.random() * 4) + 1]();
            }

            console.log(this.randomVictoryMessage);

            const backendTime = new Date(this.$store.state.myChallengesComplete[0].end_date);
            const diffInMs = new Date() - backendTime;
            const diffInMinutes = diffInMs / (1000 * 60);
            if (diffInMinutes < 1) {
                setTimeout(() => (this.popupRatingDif = true), 500);
                setTimeout(() => (this.popupEasyEnter = true), 1000);
                setTimeout(() => ((this.popupEasyLeave = true), (this.popupEasyEnter = false)), 4700);
                setTimeout(() => ((this.popupRatingDif = false), (this.popupEasyLeave = false)), 5500);
            }
        },

        moreLinesSidebar() {
            if (this.$store.state.moreSidebar == false) {
                this.$store.commit("MORE_SIDEBAR", true);
            } else {
                this.$store.commit("MORE_SIDEBAR", false);
            }
        },
        // provera(payload){
        //   console.log('payload', payload)
        // },
        closeIfClickedOutside(event) {
            // console.log("lokvanj");
            if (
                !document.getElementById("checkClickChallenge")?.contains(event.target) &&
                !document.getElementById("checkClickChallenge2")?.contains(event.target) &&
                !document.getElementById("checkClickChallenge3")?.contains(event.target)
            ) {
                this.challenged = false;
                this.questionRoullette = false;
                this.$emit("questionRoullette", false);
                //  console.log("outsider", this.popupChallangeBetPart);
                //   this.$emit('changePopup')
            }
        },
        // refreshRoom(e) {
        //     let room = Array(7)
        //         .fill()
        //         .map(() => "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.random() * 62))
        //         .join("");
        //     if (e == "link") {
        //         this.linkupLink = `https://chessroulette-dev.vercel.app/room/new/op${room}?activity=meetup&theme=op&star=1`;
        //     }
        //     if (e == "lesson") {
        //         this.lessonLink = `http://localhost:4200/room/new/op${room}?activity=learn&theme=op&instructor=1&pgn=1. d4 d6`;
        //     }

        // },
        goLinkupList() {
            this.location = "linkup";
            // console.log(this.$store.state.current_user.email);
            let Linkup = true;
            let email = this.$store.state.current_user.email;
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                email: email, // Email address,
                user_hash: localStorage.getItem("H"),
                LinkupSideBar: Linkup,
            });
            //console.log('yfhytdf');
            this.routerLinkup();
        },
        routerLinkup() {
            this.$router.push({ name: "LinkupList" });
        },
        signIn() {
            this.linkBackTour = window.location.href.split("/").pop();
            if (this.linkBackTour !== "") {
                this.$router.push({ path: `/login?state=${this.linkBackTour}` });
            } else {
                this.$router.push("/login");
            }
        },
        signUp() {
            this.linkBackTour = window.location.href.split("/").pop();
            if (this.linkBackTour !== "") {
                this.$router.push({ path: `/?state=${this.linkBackTour}` });
            } else {
                this.$router.push({ name: "home" });
            }
        },
        openInvite() {
            this.inviteComponent = !this.inviteComponent;
        },
        goToProfile() {
            this.$router.push({ name: "Profile", params: { id: this.userId } }).catch(error => {
                if (error.name != "NavigationDuplicated") {
                    throw error;
                }
            });
            this.$emit("closeBlog");
        },
        goToHome() {
            this.$emit("toggleSidebarParentClose");
            this.$emit("reload");
        },
        blogRout() {
            this.$emit("openBlog");
            this.$router.push({ name: "Profile", params: { id: this.userId, route: "clickActive2" } }).catch(error => {
                if (error.name != "NavigationDuplicated") {
                    throw error;
                }
            });
        },
        receiveOnlineList(payload) {
            this.$emit("onlineFromSideBar");
            //   console.log('kiiki',payload)
            this.$store.commit("ONLINE_USERS", payload);
        },
        frontend_version(payload) {
            console.log("V", payload);
        },
        async goToRoullete() {
            try {
                this.newToken = await checkToken();
            } catch (err) {
                this.error = "Failed to load data";
            } finally {
                if (this.newToken) {
                    localStorage.setItem("token", this.newToken);
                } else {
                    this.newToken = localStorage.getItem("token");
                }
                Cookies.set("sessionToken", this.newToken, {
                    domain: ".outpostchess.com",
                    path: "/",
                    secure: true,
                    sameSite: "None", // Important for cross-subdomain + HTTPS
                    expires: 7, // optional: expires in 7 days
                });
                //console.log("ide to bas ");
                this.questionRoullette = false;
                this.$emit("questionRoullette", false);
                if (window.innerWidth < 500) {
                    window.open(this.roulleteURL, "_self");
                } else {
                    window.open(this.roulleteURL, "_self");
                }
            }
        },
        cancelToRoullete() {
            this.questionRoullette = false;
            this.$emit("questionRoullette", false);
        },
        receiveMessageSidebar(payload) {
            this.$store.commit("NOTIFICATION_PAYLOAD", payload);

            // console.log("1", payload.n_type);

            if (
                payload.type == "NOTIFICATION" &&
                (payload.n_type == "challenge_accepted" ||
                    payload.n_type == "challenge_started" ||
                    payload.n_type == "challenge_initiated" ||
                    payload.n_type == "challenge_accepted")
            ) {
                this.$emit("refreshNotification");
                let audio = new Audio(require("@/assets/Sounds/chess-pieces.mp3"));
                audio.play();
            }

            if (payload.type == "NOTIFICATION" && payload.n_type == "challenge_accepted") {
                this.questionRoullette = true;
                this.$emit("questionRoullette", true);
                this.roulleteURL = payload.data.url;
                this.payloadRoulette = payload;
            }
            if (payload.type == "NOTIFICATION" && payload.n_type == "challenge_started") {
                this.roulleteURL = payload.data.url;
                this.payloadRoulette = payload;
                // window.open(this.roulleteURL, "_self");
            }

            if (payload.type == "NOTIFICATION" && payload.n_type == "challenge_initiated") {
                this.challenged = true;
                //  this.roulleteURL = payload.data.url;
                this.payloadIniciationChallenge = payload;
            }

            if (
                payload.type == "MESSAGE" &&
                payload.i_am_sender == false &&
                payload.from_obj.user_uuid !== window.location.href.split("/").pop()
            ) {
                //this.$store.dispatch("getMessageInfo");
                // this.$store.commit("PATCH_MESSAGE",payload);
                for (let i = 0; i < this.$store.state.message_info?.length; i++) {
                    if (
                        this.$store.state.message_info[i].conv_uuid == payload.conversation_uuid &&
                        this.$store.state.message_info[i]?.msg_id < payload?.msg_id
                    ) {
                        this.unreadMessage = true;
                        // this.$store.state.message_info[i].msg
                    }
                }
            }
        },
        messageAlert: function () {
            this.unreadMessage = false;
            for (this.i = 0; this.i < this.$store.state.message_info?.length; this.i++) {
                //    console.log('1',this.$store.state.message_info[this.i].msg_id)
                //   console.log('2',this.$store.state.message_info[this.i].last_msg_read_id )

                if (
                    this.$store.state.message_info[this.i].msg_id !==
                    this.$store.state.message_info[this.i].last_msg_read_id
                ) {
                    this.unreadMessage = true;
                    //   console.log(this.$store.state.message_info[this.i]);
                    //  console.log(this.$store.state.message_info[this.i].last_msg_read_id);
                }
            }
        },
        async challangeAccept(e) {
            try {
                this.newToken = await checkToken();
            } catch (err) {
                this.error = "Failed to load data";
            } finally {
                if (this.newToken) {
                    localStorage.setItem("token", this.newToken);
                } else {
                    this.newToken = localStorage.getItem("token");
                }
                Cookies.set("sessionToken", this.newToken, {
                    domain: ".outpostchess.com",
                    path: "/",
                    secure: true,
                    sameSite: "None", // Important for cross-subdomain + HTTPS
                    expires: 7, // optional: expires in 7 days
                });
                console.log("lobioton", e);
                fetch(process.env.VUE_APP_URL + `challenge_accept/${e.data.ch_uuid}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                    body: JSON.stringify({}),
                })
                    .then((this.challenged = false))
                    .then(response => response.json())
                    .then(data => window.open(data.target_url, "_self"));
            }
        },
        challangeDenied(e) {
            fetch(process.env.VUE_APP_URL + `challenge_deny/${e.data.ch_uuid}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({}),
            }).then((this.challenged = false));

            //  this.removeButtons = [...this.removeButtons, e.n_id]
        },
        messageAlert2() {
            //console.log("freki")
            this.unreadMessage = false;
        },
        logOut() {
            /* let fire_tok = localStorage.getItem("tok_fire");
            fetch(process.env.VUE_APP_URL + "/firebase_registration_token", {
                method: "DELETE",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    token: fire_tok,
                }),
            });  */
            localStorage.removeItem("to_event_from");
            localStorage.removeItem("to_event_from_org");
            localStorage.removeItem("tok_fire");
            localStorage.removeItem("token");
            localStorage.removeItem("id");
            localStorage.removeItem("H");
            localStorage.removeItem("tourUuid");
            this.$store.commit("SET_MY_NOTIFICATION_LOADED", false);
            window.Intercom("boot", {
                api_base: "https://api-iam.intercom.io",
                app_id: "qfb2wowv",
                name: "",
                email: null, // Email address
            });
            this.$store.commit("SET_MY_FEEDS", 0);
            this.$store.commit("ERASE_STATES", 1);
            this.goToLogin();
        },
        goToLogin() {
            this.$router.push("/login");
        },
        closeSidebar() {
            this.$emit("toggleSidebarParentClose");
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.fade-enter-active,
.fade-leave-active {
    transition-property: opacity;
    transition-duration: 2.25s;
}
* {
    transition: 0.3s;
}
.fade-enter-active {
    transition-delay: 2.25s;
}
.clicked {
    fill: rgba(255, 198, 149, 0.7) !important;
    color: rgba(255, 198, 149, 0.7) !important;
}
.fade-enter,
.fade-leave-active {
    opacity: 0;
}
a {
    text-decoration: none;
}
body::-webkit-scrollbar {
    display: none;
}
html {
    scrollbar-width: none;
}
.open {
    transform: translateX(0) !important;
}
.border-top {
    border-top: 0.5px solid rgba(199, 201, 208, 0.2) !important;
    width: 70%;
    position: relative;
    left: 2.3rem;
    margin-bottom: 8px;
    @media screen and (max-width: 640px) {
        width: 80%;
        left: 3.5rem;
    }
}
.middle2-buttons {
    margin-left: 2rem;
    border: 1px solid #c8a07d;
    color: white;
    border-radius: 8px;
    width: 8.75rem;
    height: 2.188rem;
    margin-top: 1.5rem;
    position: absolute;
    top: 82vh;
}
.btn_roullete {
    b {
        transition: 0s;
    }
    color: #202122;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid 1px solid #07da63;
    border-radius: 6px;
    margin-top: 14px;
    font-size: 16px;
    cursor: pointer;

    width: 130px;
    height: 34px;
    margin-left: 10px;
    margin-right: 10px;
    border: 1px solid #07da63;
    background-color: #07da63;
    &:hover {
        background-color: #202122;

        cursor: pointer;
        color: #ffffff;
    }
}
.more-lines {
    justify-content: flex-start;
    align-items: flex-start;
    display: flex;
    margin-left: 1.7rem;
    &:hover {
        opacity: 0.7;
        cursor: pointer;
    }
}
.btn_roullete_cancel {
    color: #ceceda;
    background-color: #202122;
    border: 1px solid #202122;
    &:hover {
        opacity: 0.5;
        cursor: pointer;
    }
}
.rotate180 {
    transform: rotate(180deg);
}
.option-down {
    height: 0px;
    opacity: 0;
}
.option-down-active {
    height: 100px;
    opacity: 1;
}

.question-roullette {
    width: 390px;
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    min-height: 130px;
    left: calc(50% - 6.125rem);
    padding-top: 50px;
    //left:50%;
    background-color: #c8a07d;
    z-index: 100;
    position: fixed;
    top: 40%;
    padding: 24px 24px;
    background-color: #202122;
    color: #ceceda;
    border-radius: 6px;
    font-size: 16px;
    border: 1px solid rgba(92, 94, 100, 0.5);
    @media screen and (max-width: 640px) {
        width: 80%;
        left: 10%;
        font-size: 16px;
    }
    box-shadow: 1.5px 1.5px 5px rgba(200, 160, 125, 0.2);
}
.buttons {
    margin-left: 2rem;
    border: 0.5px solid #5c5e64;
    color: #cecece;
    border-radius: 8px;
    width: 8.75rem;
    height: 2.188rem;
    margin-top: 1.5rem;
    display: none;
    position: absolute;
    top: 78vh;
    font-size: 14px;
}
.buttons:hover {
    border: 1px solid #c8a07d;
}
.signup {
    transition: 0.3s;
    top: 76vh;
    background-color: #c8a07d;
    &:hover {
        background-color: #202122;
    }
}
.signin {
    transition: 0.3s;
    &:hover {
        background-color: #c8a07d;
    }
}
.middle2-buttons-signup:hover {
    opacity: 0.7;
}
.middle2-buttons:hover {
    opacity: 0.7;
}
.wallet {
    margin-bottom: 10px;
}
.absolute-new {
    position: absolute;
    top: -10px;
    left: 53px;
    padding: 1px 3px;
    color: #ffffff !important;
    background-color: #f2358d;
    font-size: 11px;
    font-weight: 700;
    border-radius: 6px;
}
.opacity-zero {
    opacity: 0 !important;
}
.opacity-one {
    opacity: 1 !important;
}
.zero {
    opacity: 0;
}
.blue {
    background-color: #11c6d1;
    left: 58px;
}
.green {
    background-color: #07da63;
    left: 100px;
    color: #202122 !important;
    padding: 1px 4px;
    @media only screen and (max-width: 1440px) {
        left: 90px;
        top: -14px;
    }
    // letter-spacing: .07rem !important;
}
.side-bar {
    position: relative;
    text-align: center;
    background-color: #202122;
    position: sticky;
    top: 0;
    height: 100vh;
    width: 16.25rem;
    flex: 0 0 16.25rem;
    border-right: 1px solid rgba(84, 84, 84, 0.2);
    @media only screen and (max-width: 1440px) and (min-width: 1025px) {
        width: 12.25rem;
    }
}
.rating-dif-text {
    display: flex;
    p {
        font-size: 15px !important;
        font-weight: 600;
    }

    margin-bottom: 14px;
    img {
        margin-left: 6px;
    }
}

.logoimg {
    padding-bottom: 3.125rem;
    padding-top: 2.5rem;
    display: flex;
    margin-left: 2rem;
    width: 128px;
    img {
        width: 100%;
    }
}
.demo-links {
    margin-top: 50%;
    @media screen and (max-width: 1600px) {
        margin-top: 15%;
    }
    @media screen and (max-width: 1440px) {
        margin-top: 40%;
    }
    @media screen and (max-width: 1380px) {
        margin-top: 5%;
    }
    @media screen and (max-width: 1280px) {
        margin-top: 15%;
    }
}

.side-options {
    display: grid;
    grid-template-columns: 24% 71% 5%;
    color: #c7c9d0;
    padding: 0.625rem 0 1rem 2rem;
    position: relative;
    @media only screen and (max-width: 1440px) and (min-width: 1025px) {
        grid-template-columns: 30% 75% 5%;
        padding: 0.625rem 0 0.7rem 1rem !important;
    }
    p {
        color: #c7c9d0;
    }

    .arrow {
        display: none;
        padding-top: 6px;
    }
}

.side-options:hover {
    //   opacity: 0.7;
}

.left-sidetext {
    // padding-left: 0.8rem;
    margin: 0;
    display: flex;
    align-items: left;
    font-size: 15px;
}
.left-sidetext:hover {
    cursor: pointer;
}
.diffcol {
    color: rgba(199, 201, 208, 0.2);
}
.diffcol2:hover {
    cursor: default !important;
}

.diffcol:hover {
    opacity: 1 !important;
}

.icon {
    min-width: 40px;
    width: 40px !important;
    display: flex;
    align-items: center;
    justify-content: start;
    position: relative;
    left: 10px;
}

.contact {
    margin-bottom: 1.875rem;
}

hr {
    border: 0.5px solid rgba(199, 201, 208, 0.2);
    width: 80%;
    margin: 5px auto;
}
.color-line-div {
    width: 50px;
    min-width: 50px;
    margin-right: 1px;
    @media screen and (max-width: 1440px) {
        margin-right: 10px;
        position: relative;
        right: 2px;
        justify-content: flex-end !important;
    }
}
.loader {
    position: absolute;
    top: -85px;
    img {
        width: 300px;
        height: auto;
    }
}
.banner-text {
    color: white;
    font-size: 15px;
}
.banner-pages-position-problem {
    top: 20px !important;
    @media screen and (max-width: 640px) {
        transition: 0.3s !important;
        top: 10px !important;
    }
}
.banner-position {
    top: 20px !important;
    @media screen and (max-width: 640px) {
        transition: 0.3s !important;
        top: 50px !important;
    }
}
.initiate-banner {
    position: absolute;
    width: 50vw;
    left: 25vw;
    // top:20px;
    background-color: #202122 !important;
    border: 1px solid rgba(111, 115, 129, 0.5) !important;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 2.813rem;
    border-radius: 20px;
    transition: 0.3s !important;
    padding: 12px 15px;
    top: -300px;
    @media screen and (max-width: 640px) {
        top: -200px;
        z-index: 10;
        min-height: 110px;

        left: 5vw;
        width: 90vw;

        svg {
            margin-right: 16px;
        }
    }
}
.side-flexend2 {
    border-top: 0.5px solid rgba(199, 201, 208, 0.2);
    width: 80%;
    margin-inline: auto;
}
.side-bar::webkit-scrollbar {
    display: none;
}
.color-line-red {
    width: 18px;
    height: 2px;
    background-color: #f2358d;
    margin-right: 6px;
}
.color-line-blue {
    width: 18px;
    height: 2px;
    background-color: #11c6d1;
    margin-right: 6px;
}
.side-bar {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */
}
.top {
    height: 133px;
}
#message_notification {
    color: white;
    position: absolute;
    top: 0.7rem;
    left: 130px;
    //left: 120px;
    border: 1px solid #11c6d1;
    border-radius: 50%;
    background-color: #11c6d1;
    height: 0.5rem;
    width: 0.5rem;
    z-index: 10;
    @media only screen and (max-width: 1440px) {
        left: 120px;
    }
}

.close-icon {
    display: none;
}

@media only screen and (max-width: 1500px) {
    .side-options {
        padding: 0.625rem 0 1rem 2rem;
    }
    .side-bar {
        min-height: 100vh;
    }
}

@media screen and (max-width: 1024px) {
    #message_notification {
        left: 85px;
    }
    .side-bar {
        min-height: 100vh;
    }
    .lg-hide {
        display: none;
    }
    .side-flexend2 {
        margin-inline: 0;
        width: 100%;
        display: none;
    }
    .side-bar {
        transform: translateX(-100%);
        position: fixed;
        z-index: 100;
        width: 23.25rem;
        left: 0;

        .arrow {
            display: block;
            margin-left: auto;
            padding-right: 2.625rem;
        }
    }
    .options {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 50%;
    }
    .wallet {
        margin-bottom: 0rem;
    }
    .blog {
        margin-block: 0rem;
        padding-block: 0;
    }
    #side-flexend {
        padding-top: 0;
    }
    .settings {
        padding-top: 1.438rem;
    }
    .contact {
        margin-bottom: 1.25rem;
    }
    .close-icon {
        display: block;
        padding-bottom: 1.2rem;
        cursor: pointer;
    }

    .top {
        width: auto;
        padding-right: 2.625rem;
        padding-left: 0rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 133px;
    }

    .side-options {
        padding-left: 4.125rem;
        grid-template-columns: 15% 65% 20%;

        a p {
            font-size: 16px;
        }
    }

    .middle2-buttons {
        border: 1px solid #c8a07d;
        color: white;
        border-radius: 8px;
        width: 8.75rem;
        height: 2.188rem;
        margin-left: 5.417rem;
        margin-top: 1.563rem;
        font-size: 16px;
    }
}

@media screen and (max-width: 768px) {
    #message_notification {
        left: 180px;
    }
    .side-bar {
        width: 40rem;

        .arrow {
            padding-right: 4.786rem;
        }
    }
    .top {
        padding-right: 4.786rem;
        padding-left: 0rem;
    }
    .logoimg {
        padding-bottom: 3.167rem;
        margin-left: 3.5rem;
    }

    .side-options {
        padding-left: 70px;
        padding-top: 0.5rem;
        padding-bottom: 0.75rem;
        a p {
            font-size: 16px;
        }
    }
    .left-sidetext {
        font-size: 16px;
    }
    .middle2-buttons {
        font-size: 16px;
        height: 2.975rem;
        width: 11.539rem;
        margin-left: 6.292rem;
    }
}

@media screen and (max-width: 640px) {
    .buttons {
        margin-left: 3.5rem;
        display: block;

        font-size: 16px;
        width: 169px;
        height: 39px;
    }
    .blog {
        border-top: 6.5px solid rgba(199, 201, 208, 0.2) !important;
        padding-left: 3.5rem !important;
        padding-top: 16px !important;
        margin: 0;
    }
    #message_notification {
        left: 175px;
    }
    .side-bar {
        width: 100%;
    }
    .left-sidetext {
        font-size: 16px;
    }
    .top {
        padding-left: 0;
    }
    .side-options {
        padding-left: 3.5rem;
        padding-top: 0.3rem;
        padding-bottom: 0.55rem;
        display: grid;
    }
    .options {
        height: 50%;
    }
}

@media screen and (max-width: 425px) {
    .close-icon {
        padding-bottom: 2rem;
    }
    #message_notification {
        left: 150px;
    }
}

@media screen and (max-width: 375px) {
    .close-icon {
        padding-bottom: 3rem;
    }
    .top {
        padding-right: 3.5rem;
    }
    .side-options {
        .arrow {
            padding-right: 3.5rem;
        }
    }
}
</style>
